import axios from 'axios';

export const fetchScoreBoardInfo = async (key) => {

    try {
        const response = await axios.post(`/api/ScoreBoard/GetScoreBoardInfoByKey`, { Key: key });
        if (response && response.status === 200) {
            return response.data;
        } else {
            console.error("fetch member detail error.")
            return response.status;
        }
    } catch (error) {
        if (error.response.status === 401) {
            return error.response.status;
        }
    }
}
export const fetchPlayersScoreByTournament = async (key, cols) => {
    try {
        const response = await axios.get(`/api/ScoreBoard/GetPlayerScoreListByKey`, { params: { key: key, cols: cols.join(",") } });
        if (response && response.status === 200) {
            return response.data.records;
        } else {
            console.error("fetch member detail error.")
            return response.status;
        }
    } catch (error) {
        if (error.response.status === 401) {
            return error.response.status;
        }
    }
}
export const fetchPlayersByTournament = async (key) => {
    try {
        const response = await axios.post(`/api/Player/GetPlayerListByKey`, { Key: key });
        if (response && response.status === 200) {
            return response.data.records;
        } else {
            console.error("fetch member detail error.")
            return response.status;
        }
    } catch (error) {
        if (error.response.status === 401) {
            return error.response.status;
        }
    }
}
